/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appointmentServices = sqliteTable('appointment_services', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  name: text('name'),
  category_id: text('category_id'),
  description: text('description'),
  typical_duration_mins: integer('typical_duration_mins'),
  price_cents: integer('price_cents'),
  active: integer('active'),
  is_lab_test: integer('is_lab_test'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
